export default "__VITE_ASSET__C$TvLuOQ__"